<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="shopName" placeholder="请输入商户名称" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getFilterList">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="default" @click="handleClear()">重置</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表 @selection-change="handleSelectionChange"-->
		<el-table :data="tableData" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<!-- <el-table-column type="selection" width="45"></el-table-column> -->
			<el-table-column prop="id" label="ID" width="80">
			</el-table-column>
			<el-table-column prop="avatar" label="商户logo" width="100">
				<template slot-scope="image">
                    <img class="avatar" :src="image.row.avatar?image.row.avatar:require('../../assets/avatar.png')"  min-width="70" height="70" />
                 </template>
			</el-table-column>
			<el-table-column prop="shopName" label="商户名称" width="180">
			</el-table-column>
			<el-table-column prop="shopVocation" label="行业" width="100">
			</el-table-column>
			<el-table-column prop="linkman" label="联系人" width="100">
			</el-table-column>
			<el-table-column prop="telphone" label="联系电话" width="100">
			</el-table-column>
			<el-table-column prop="shopLocation" label="店铺地址" width="250">
			</el-table-column>
			 <el-table-column label="剩余金额" >
				<template slot-scope="scope">
					<el-button type="text"  @click="handleDetails(scope.$index, scope.row)">{{scope.row.remainder}}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="作品数" >
				<template slot-scope="scope">
					<el-button type="text"  @click="handleWorks(scope.$index, scope.row)">{{scope.row.workNum}}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="卡券数" >
				<template slot-scope="scope">
					<el-button type="text"  @click="handleCoupon(scope.$index, scope.row)">{{scope.row.couponNum}}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="员工" >
				<template slot-scope="scope">
					<el-button type="text" @click="handleStaff(scope.$index, scope.row)">{{scope.row.staffNum}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="checkStatus" align="center" label="状态"  :formatter="formatCheckStatus" width="120"></el-table-column> 
			<el-table-column label="操作" width="180" class="button-bar" fixed='right' align="center"> 
				<template slot-scope="scope">
					<el-button type="text"  size="small" :disabled="scope.row.checkStatus ==1 || scope.row.checkStatus ==3?false:true" @click="handleAuthen(scope.$index, scope.row)" >认证</el-button>
					<el-button type="text"  size="small" :disabled="scope.row.checkStatus ==4?false:true"  @click="handReliveCheckMerchantInfo(scope.$index, scope.row)">解除认证</el-button>
					<el-button type="text"  size="small" @click="handleDetail(scope.$index, scope.row)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination  background layout="total,prev, pager, next, jumper, sizes" @current-change="handleCurrentChange"
				@size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage"
				:page-size="pageSize" :total="totalNumber" style="float:left;">
			</el-pagination>
		</el-col>
		 <Dialog v-if="isShow" :propsData="propsData" @fatherMethod="getList(0)"></Dialog>
		 <!-- @child-ok="childok" @child-cancel="childcancel" -->
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import Dialog  from '../../components/shopDetail.vue'
	//import NProgress from 'nprogress'
	import { getUserListPage, removeUser, batchRemoveUser, editUser, addUser } from '../../api/api';

	export default {
		components: {
			Dialog
		},
		data() {
			return {
				totalNumber: null,
				tableData: null,
				pageSize: 10,
				currentPage: 1,
				checkState: [{ label: '未认证', value: '0' },{ label: '未认证', value: '1' }, { label: '待审核', value: '2' }, { label: '认证失败', value: '3' }, { label: '认证成功', value: '4' }],
				users: [],
				listLoading: false,
				shopName:"",
				isShow:false,
				propsData:{}
			}
		},
		methods: {
			handleClear(){
				this.shopName ="";
				this.getFilterList();
			} ,
			formatDatas(item) {
				return {
					id: item.userId,
					merchantId:item.merchantId,
					avatar: item.shopLogo||item.avatar||'',
					nickName:item.nickName||'',
					shopName:item.shopName,
					linkman: item.linkman||item.username,
					telphone:item.telphone||'',
					shopVocation:item.shopVocationValue||'',
					shopLocation:item.shopLocation||'',
					checkStatus:item.checkStatus||0,
					remainder: item.wallet&&item.wallet.remainder||0,
					workNum:item.workNum||0,
					couponNum:item.couponNum||0,
					staffNum:item.staffNum||0,
				};
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage);
			},
			getFilterList() {
				this.currentPage = 1;
				this.getList(this.currentPage );
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage);
			},
			async getList(index) {
				let condition = {}
				condition.shopName = this.shopName;
				condition.currentPage =index;
				condition.pageSize =this.pageSize;
				try{
					this.listLoading = true;
					let result = await this.$http.post(this,'/merchant/getMerchantList', {},condition);
					if (result && result.code == 200) {
						debugger
						this.tableData = result.data.rows.map((item) => { return this.formatDatas(item) });
						this.totalNumber = result.data.total
						this.listLoading = false;
					}
				} catch(e){
					this.listLoading = false;
				}

			},
			formatCheckStatus(row, column) {
				let temp = this.checkState.filter((item) => {
					return item.value == row.checkStatus;
				})
				return temp[0].label;
			},
			handleWorks(index, row)  {
				this.$router.push({ path: '/businessUser/works', query: { userid: row.id,userName:row.nickName,avatar:row.avatar,totalWorks:row.workNum } });
			},
			handleDetails(index,row){
				this.$router.push({ path: '/businessUser/details', query: { userId: row.id,userName: row.nickName ,avatar:row.avatar,} });
			},
			handleCoupon(index,row){
				this.$router.push({ path: '/businessUser/coupon', query: { merchantId: row.merchantId,shopName: row.shopName ,avatar:row.avatar,couponNum:row.couponNum} });
			},
			handleStaff(index,row){
				this.$router.push({ path: '/businessUser/staff', query: { userId:row.userId,merchantId: row.merchantId,shopName: row.shopName ,avatar:row.avatar,staffNum:row.staffNum} });
			},
			async handleAuthen(index,row){
				this.propsData ={};
				this.propsData.merchantId = row.merchantId;
				this.propsData.showCz =true;
				this.isShow =true;
			},

			handReliveCheckMerchantInfo(index,row){
				let _this =this;
				_this.$prompt('', '解除认证的原因', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				}).then(({ value }) => {
					_this.reliveCheckMerchantInfo(value,row.merchantId);
				}).catch(() => {
				
				});
			},
			async reliveCheckMerchantInfo(value,merchantId){
				let condition ={};
				condition.merchantId = merchantId;
				condition.failReason = value;
				let result  =  await this.$http.post(this,'/merchant/reliveCheckMerchantInfo', {},condition);
				if (result && result.code == 200) {
					this.$message({
						type: 'info',
						message: '解除认证成功'
					});     
					this.getList(0);
				}
			},

			handleDetail(index,row){
				let data = row;
				this.propsData ={};
				this.propsData.merchantId = row.merchantId;
				this.propsData.dialogVisible = true;
				this.propsData.showCz =false;
				this.isShow =true;
			}
		},
		mounted() {
			this.getList(0);
		}
	}

</script>

<style scoped>
	.el-button+.el-button {
		margin-left: 4px;
	}

	.el-button--small,
	.el-button--small.is-round {
		padding: 8px 10px;
	}

	.el-button--text {
		padding-left: 0;
		padding-right: 0;
	}
	.avatar {
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}

	.comf-btn {
		display: flex;
		justify-content: flex-end;
	}
</style>
